<template>
  <div class="productDropdownSearchContainer bg-white">
    <div class="bb searchHeader bg-white">
      <input
        ref="searchQuery"
        v-model="search"
        class="no-border body-copy-2 icon-search width-100 pl-25 bg-white"
        placeholder="Search Bulletin for Products"
        type="search"
      />
    </div>
    <div class="clear" />

    <div class="results">
      <div v-for="result in results" :key="result.id" class="result">
        <div class="result-productWrapper hover-bg-green pointer px-8 mb-5 mt-5" @click="handleAddProductClick(result)">
          <div class="productDescription">
            <a class="product-name">
              {{ result.title }}
            </a>
          </div>
        </div>
      </div>
      <div v-if="showNoResults" class="result">
        <div class="result-productWrapper px-8 mb-5 mt-5">no results</div>
      </div>
    </div>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
import _debounce from "lodash/debounce";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      search: "",
      productSearchIndex: null,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      isLoading: false,
      results: [],
      showNoResults: false,
    };
  },
  watch: {
    search: function () {
      this.searchForProductSuggestions();
    },
  },
  mounted() {
    this.productSearchIndex = this.algoliaClient.initIndex(this.$env.getOrigin() + "_products_created_at_asc");
    this.searchForProductSuggestions();
    this.$refs.searchQuery.focus();
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
  methods: {
    // eslint-disable-next-line no-magic-numbers
    searchForProductSuggestions: _debounce(searchForProductSuggestions, 500),
    handleAddProductClick,
  },
};

function searchForProductSuggestions() {
  this.isLoading = true;
  this.productSearchIndex.clearCache();
  this.productSearchIndex
    .search(this.search, {
      hitsPerPage: 100,
      distinct: false,
      page: 0,
      facets: "*,active,brand.id",
      facetFilters: [
        ...this.$utils.constants.ALGOLIA_DEFAULT_PRODUCT_SEARCH_FACET_FILTER,
        this.user.role === "BRAND" ? ["brand.id:" + this.user.brand_id] : [],
      ],
      numericFilters: this.$utils.constants.ALGOLIA_DEFAULT_PRODUCT_SEARCH_NUMERIC_FILTER,
    })
    .then((response) => {
      this.showNoResults = response.nbHits === 0;
      this.results = response.hits.map((result) => ({
        image: result.image,
        product_thumbnail_url: result.image,
        title: result.name,
        wholesale_price: result.wholesale_price,
        retail_price: result.pos_price,
        url: `/products/${result.brand.company_name}/${result.id}`,
        product_id: result.id,
        parent_category: result.parent_category,
        tag_type: "product",
        categories: result.categories,
      }));
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      this.isLoading = false;
    });
}

function handleAddProductClick(productData) {
  this.$emit("product-added", productData);
}
</script>

<style lang="scss" scoped>
.productDropdownSearchContainer {
  width: 205px;
  height: 122px;
  overflow: hidden;
  margin-left: -10px;

  .searchHeader {
    background: white;

    input {
      background-size: 6%;
      background-position: 7px 12px;
      height: 35px;
      outline: none;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 17px;
      letter-spacing: 0.08em;
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .results {
    height: 90px;
    background: white;
    overflow: scroll;

    .result {
    }
  }

  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 6px;
}
</style>
